import { render } from "./componentHtml.vue?vue&type=template&id=256a62da"
import script from "./componentHtml.vue?vue&type=script&lang=js"
export * from "./componentHtml.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__